
import * as actions from "../actions";
import Timer from "../../../common/timer";
import React from 'react'
import { connect } from 'react-redux';

class FileUploadStage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { disabled } = this.props;
    const { isUploading, percentComplete, stagedFiles, selectedFiles, exceedsFileLimit, maxFiles } = this.props.state.fileupload;
    if (stagedFiles.count === 0) {
      return null;
    }

    const stageClassName = stagedFiles.count === 1? "single-file": "multi-file";
    return (
      <div className={`file-uploader-stage ${stageClassName}`}>
        <StagedPhotoPanel
          disabled={disabled}
          stagedFiles={stagedFiles}
          selectedFiles={selectedFiles}
          exceedsFileLimit={exceedsFileLimit}
          maxFiles={maxFiles}
        />
        { this.props.exceedsFileLimit && !isUploading &&
          <span className="staged-files-notification">Note: Max {maxFiles} files per upload</span>
        }
        { isUploading &&
          <ProgressBar percentComplete={percentComplete}/>
        }
      </div>
    );
  }

  componentWillUnmount() {
    actions.resetFileUploader();
  }
}

class StagedPhotoPanel extends React.Component {
  constructor(props) {
    super(props);

    this.resetMaxPhotosError = this.resetMaxPhotosError.bind(this);
    this.canAddToSelection = this.canAddToSelection.bind(this);
    this.addFileToSelection = this.addFileToSelection.bind(this);
    this.removeFileFromSelection = this.removeFileFromSelection.bind(this);
    this.handleTextAnimationComplete = this.handleTextAnimationComplete.bind(this);
    this.handleMaxPhotoErrorAnimationComplete = this.handleMaxPhotoErrorAnimationComplete.bind(this);

    this.textAnimationTimer = new Timer(150, 1);
    const cssAnimationDuration = 7000;
    this.maxPhotoErrorAnimationTimer = new Timer(cssAnimationDuration - 150, 1);

    this.isAnimatingScroll = false;

    let { selectedFiles } = props;

    this.state = {
      animateSelectedPhotosText: selectedFiles.count > 0,
      showMaxPhotosErrorText: false
    };

    this.previousStagedFilesCount = 0;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.animateSelectedPhotosText !== nextState.animateSelectedPhotosText ||
      this.state.showMaxPhotosErrorText !== nextState.showMaxPhotosErrorText ||

      this.props.stagedFiles.count !== nextProps.stagedFiles.count ||
      this.props.selectedFiles.count !== nextProps.selectedFiles.count ||
      this.props.exceedsFileLimit !== nextProps.exceedsFileLimit ||
      this.props.disabled !== nextProps.disabled ||
      this.props.stagedFiles.files.join('-') !== nextProps.stagedFiles.files.join('-') ||
      this.props.selectedFiles.files.join('-') !== nextProps.selectedFiles.files.join('-')
    );
  }

  render() {
    let fileNodes = [];
    let { stagedFiles, selectedFiles, exceedsFileLimit, maxFiles, disabled } = this.props;
    const showMaxPhotosErrorText = exceedsFileLimit || this.state.showMaxPhotosErrorText && selectedFiles.count >= maxFiles;

    for(let index = 0; index < stagedFiles.count; index++) {
      let backgroundImageUrl = stagedFiles.files[index];

      fileNodes.push(
        <StagedPhotoPanelItem
          disabled={disabled}
          backgroundImageUrl={backgroundImageUrl}
          key={index}
          resetMaxPhotosError={this.resetMaxPhotosError}
          canAddToSelection={this.canAddToSelection}
          addFileToSelection={this.addFileToSelection}
          removeFileFromSelection={this.removeFileFromSelection}
        />
      );
    }

    const isMultipleFiles = stagedFiles.count > 1;
    const numPhotosClassName = `stage-photo-panel-num-selected-photos ${this.state.animateSelectedPhotosText? 'animate': 'hidden'}`;
    const panelText = selectedFiles.count === 1? 'photo selected': 'photos selected';
    const numIgnoredPhotos = stagedFiles.count - selectedFiles.count;
    const pluralizedImageText =  numIgnoredPhotos === 1? 'image': 'images';

    return (
      <div className="stage-photo-panel">
        {isMultipleFiles &&
          <div className="stage-photo-panel-header">
            <strong className={numPhotosClassName}>{selectedFiles.count} </strong>
            <span className="stage-photo-panel-text">{panelText}</span>
          </div>
        }

        {showMaxPhotosErrorText &&
          <div className="exceeds-limit-error-message">
            Cannot upload more than <strong>{maxFiles}</strong> files at once.
            {numIgnoredPhotos > 0 &&
              <div>Ignoring <strong>{numIgnoredPhotos}</strong> {pluralizedImageText}.</div>
            }
          </div>
        }

        <ul className="stage-photo-panel-list">
          {fileNodes}
        </ul>
      </div>
    );
  }

  componentWillMount() {
    this.textAnimationTimer.on(Timer.COMPLETE, this.handleTextAnimationComplete);
    this.maxPhotoErrorAnimationTimer.on(Timer.COMPLETE, this.handleMaxPhotoErrorAnimationComplete);
  }

  componentWillUnmount() {
    this.textAnimationTimer.off(Timer.COMPLETE, this.handleTextAnimationComplete);
    this.maxPhotoErrorAnimationTimer.off(Timer.COMPLETE, this.handleMaxPhotoErrorAnimationComplete);

    this.textAnimationTimer.stop();
    this.maxPhotoErrorAnimationTimer.stop();
  }

  componentDidMount() {
    this.tryShowNewestAddedFiles();

    this.setState((state, props) => {
      let { stagedFiles, exceedsFileLimit, maxFiles } = props;

      if(
        !state.showMaxPhotosErrorText &&
        !this.maxPhotoErrorAnimationTimer.isRunning &&
        (exceedsFileLimit || stagedFiles.count > maxFiles)
      ){
        this.maxPhotoErrorAnimationTimer.restart();
        return { showMaxPhotosErrorText: true };
      }
    });
  }

  componentDidUpdate() {
    this.tryShowNewestAddedFiles();

    if (this.maxPhotoErrorAnimationTimer.isRunning && this.state.showMaxPhotosErrorText) {
      this.maxPhotoErrorAnimationTimer.restart();
    }
  }

  tryShowNewestAddedFiles() {
    let count = this.props.stagedFiles.count;
    if (this.props.stagedFiles.count > this.previousStagedFilesCount) {
      this.previousStagedFilesCount = count;
      this.showLastPhotoInList();
    }
  }

  showLastPhotoInList() {
    if (!this.isAnimatingScroll) {
      this.isAnimatingScroll = true;
      const $panelList = $('.stage-photo-panel-list');
      $panelList.animate(
        { scrollTop: $panelList.prop("scrollHeight") },
        {
          queue: false,
          duration: 750,
          done: () => {
            this.isAnimatingScroll = false;
          }
        }
      );
    }
  }

  canAddToSelection() {
    let { selectedFiles, maxFiles } = this.props;
    return selectedFiles.count + 1 <= maxFiles;
  }

  addFileToSelection(url) {
    this.resetTextAnimation();
    actions.addFileToSelection(url);
  }

  removeFileFromSelection(url) {
    this.resetTextAnimation();
    actions.removeFileFromSelection(url);
  }

  resetTextAnimation() {
    this.setState({ animateSelectedPhotosText: true });
    this.textAnimationTimer.restart();
  }

  resetMaxPhotosError() {
    this.setState({ showMaxPhotosErrorText: true });
    this.maxPhotoErrorAnimationTimer.restart();
  }

  handleTextAnimationComplete() {
    this.textAnimationTimer.stop();
    this.setState({ animateSelectedPhotosText: false });
  }

  handleMaxPhotoErrorAnimationComplete() {
    this.maxPhotoErrorAnimationTimer.stop();
    this.setState({ showMaxPhotosErrorText: false });
  }
}

class StagedPhotoPanelItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: false, disabled: !props.backgroundImageUrl };
    this.handelClick = this.handelClick.bind(this);
    this.updatedActiveState = this.updatedActiveState.bind(this);
  }

  render() {
    let { backgroundImageUrl } = this.props;
    const panelStyle = backgroundImageUrl? { backgroundImage: `url(${backgroundImageUrl})` }: {};
    const activeClassName = this.state.active? 'active': 'inactive';
    const className = `stage-photo-panel-item ${disabled? 'disabled': 'enabled'} ${activeClassName}`;

    if(this.props.disabled){
      this.state.disabled = true;
    }

    const { disabled } = this.state;

    const title =
      disabled? '':
        this.state.active? 'Click to Deselect Image':
          'Click to Select Image';
    return (
      <li className={className}>
        <a
          href="javascript:void 0"
          className="preview-panel"
          style={panelStyle}
          role="button"
          onClick={this.handelClick}
          title={title}
        >
          { !backgroundImageUrl &&
            <div className="css-spinner"></div>
          }
          { backgroundImageUrl &&
            <i className="icon-tick"></i>
          }
        </a>
      </li>
    );
  }

  componentDidMount() {
    this.setState((state, props) => {
      if (props.backgroundImageUrl && props.canAddToSelection()) {
        props.addFileToSelection(props.backgroundImageUrl);
        return { active: true }
      }

      return null;
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.backgroundImageUrl !== nextProps.backgroundImageUrl) {
      this.props.removeFileFromSelection(this.props.backgroundImageUrl);

      if (!nextProps.backgroundImageUrl) {
        this.setState({ active: false, disabled: true });
      }
      else if (this.props.canAddToSelection()) {
        this.setState({ active: true, disabled: nextProps.disabled });
        this.props.addFileToSelection(nextProps.backgroundImageUrl);
      }
    }
  }

  componentWillUnmount() {
    if (this.state.active) {
      this.props.removeFileFromSelection(this.props.backgroundImageUrl);
    }
  }

  handelClick(event) {
    event.preventDefault();

    if (!this.state.disabled) {
      this.setState(this.updatedActiveState);
    }

    return false;
  }

  updatedActiveState(state, props) {
    const { backgroundImageUrl } = this.props;

    if (!backgroundImageUrl) {
      return { active: false };
    }

    if (state.active) {
      props.removeFileFromSelection(backgroundImageUrl);
      return { active: false };
    }


    if (this.props.canAddToSelection()) {
      props.addFileToSelection(backgroundImageUrl);
      return { active: true };
    } else {
      this.props.resetMaxPhotosError();
    }
    return {};
  }
}

class ProgressBar extends React.Component {
  render() {
    const percentComplete = this.props.percentComplete;
    const innerStyle = {
      width: `${percentComplete}%`
    };

    return (
      <div className="upload-progress">
        <h3>
          Uploading<i className="loading-ellipsis"/>
        </h3>
        <div className="bar">
          <div className="inner" style={innerStyle}></div>
        </div>
        <a href="#" onClick={this.handleCancelUpload}>
          <i className="icon-cancel"></i>
        </a>
      </div>
    )
  }

  handleCancelUpload(e) {
    e.preventDefault();
    actions.cancelUpload();
  }
}

function mapStateToProps(state) {
  return {
    state: {
      fileupload: state.fileupload
    }
  };
}

const connectedFileUploadStage = connect(mapStateToProps)(FileUploadStage);

export default connectedFileUploadStage;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/file-uploader/components/file-upload-stage.es6